import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { confirmPasswordReset } from "./PasswordResetAPI";

// Async thunk to confirm password reset
export const confirmPasswordResetAsync = createAsyncThunk(
  "password/reset",
  async ({ email, code, password, password_confirmation }, { rejectWithValue }) => {
    try {
      return await confirmPasswordReset({ email, code, password, password_confirmation });
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const passwordSlice = createSlice({
  name: "password",
  initialState: {
    loading: false,
    success: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(confirmPasswordResetAsync.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.error = null;
      })
      .addCase(confirmPasswordResetAsync.fulfilled, (state) => {
        state.loading = false;
        state.success = true;
      })
      .addCase(confirmPasswordResetAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default passwordSlice.reducer;
